import { render, staticRenderFns } from "./BookSlider.vue?vue&type=template&id=19a6a418"
import script from "./BookSlider.vue?vue&type=script&lang=js"
export * from "./BookSlider.vue?vue&type=script&lang=js"
import style0 from "./BookSlider.vue?vue&type=style&index=0&id=19a6a418&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports